// ─── Workshop Truck Availability Tracker ───
// KPICard – Key performance indicator display tile
// IASL Technical Academy / Lafarge Driving Institute, Nigeria

import type { ReactNode } from 'react'

interface KPICardProps {
  title: string
  value: string | number
  subtitle: string
  icon: ReactNode
  iconBg: string        // Tailwind bg class e.g. "bg-blue-100"
  valueColor?: string   // Optional Tailwind text class e.g. "text-green-600"
  highlight?: boolean   // Adds amber ring if true
}

export default function KPICard({
  title,
  value,
  subtitle,
  icon,
  iconBg,
  valueColor,
  highlight,
}: KPICardProps) {
  return (
    <div
      className={`bg-white rounded-xl shadow-sm p-5 transition-shadow hover:shadow-md
        ${highlight ? 'ring-2 ring-amber-400' : ''}`}
    >
      {/* Top row: icon + title */}
      <div className="flex items-center gap-3 mb-2">
        <div
          className={`w-12 h-12 rounded-full flex items-center justify-center ${iconBg}`}
        >
          {icon}
        </div>
        <span className="text-sm font-medium text-gray-500 uppercase tracking-wide">
          {title}
        </span>
      </div>

      {/* Value */}
      <p className={`text-3xl font-bold mt-2 ${valueColor ?? 'text-gray-800'}`}>
        {value}
      </p>

      {/* Subtitle */}
      <p className="text-xs text-gray-500 mt-1">{subtitle}</p>
    </div>
  )
}
